// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"84c5efd6","977":"eff09569"}[chunkId] + ".chunk.js";
};